module.exports = "/*a {\r\n    font-size: 15px;\r\n}\r\n*/\r\n.margin-bottom-nagative-25{\r\n    margin-bottom:-22px !important;\r\n}\r\n.menu_dark .sidebar .menu .list a {\r\n  color: white !important;\r\n}\r\n/*.menu_dark .sidebar .menu .list a {\r\n  color: #ebeef0;\r\n}*/\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navmenu/navmenu.component.css
// module id = ./src/app/components/navmenu/navmenu.component.css
// module chunks = main